export const perPageOptions = [12, 16, 20, 24];
